import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { signupServ } from "../../services/authentication.services"; 
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, Link } from "react-router-dom";
import "./login.css";

function Signup() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      confirmPassword: "",
      phone:""
    },
    validationSchema: Yup.object({
      firstName: Yup.string().trim().required("First name is required"),
      lastName: Yup.string().trim().required("Last name is required"),
      phone: Yup.string().trim().required("Phone is required"),
      email: Yup.string()
        .trim()
        .matches(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/, "Invalid email format")
        .required("Email is required"),
      password: Yup.string()
        .trim()
        .min(6, "Password must be at least 6 characters")
        .required("Password is required"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password"), null], "Passwords must match")
        .required("Confirm password is required"),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);
      try {
        // Exclude confirmPassword from the payload sent to API
        const { confirmPassword, ...payload } = values;
        const response = await signupServ(payload);

        if (response?.data?.statusCode == "200" || response?.status == 201) {
          toast.success(response?.data?.message || "Account created successfully!");
          navigate("/"); 
        } else {
          toast.error(response?.data?.message || "Registration failed");
        }
      } catch (error) {
        toast.error(error?.response?.data?.message || "Something went wrong");
      }
      setSubmitting(false);
    },
  });

  return (
    <div className="signin-container">
      <div className="signin-card">
        <div className="d-flex align-items-center mb-3">
<img src="/assets/images/logo.png" alt="Eduverse Logo" className="me-2" style={{height:"50px"}}/>
        <h2 className="mb-0">Create Account</h2>
        </div>
        
        <form onSubmit={formik.handleSubmit}>
          
          <div className="row">
            {/* First Name */}
            <div className="col-md-6 mb-3">
              <label htmlFor="firstName" className="form-label">First Name</label>
              <input
                type="text"
                className={`form-control ${formik.touched.firstName && formik.errors.firstName ? "is-invalid" : ""}`}
                id="firstName"
                name="firstName"
                placeholder="John"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.firstName}
              />
              {formik.touched.firstName && formik.errors.firstName && (
                <small className="text-danger">{formik.errors.firstName}</small>
              )}
            </div>

            {/* Last Name */}
            <div className="col-md-6 mb-3">
              <label htmlFor="lastName" className="form-label">Last Name</label>
              <input
                type="text"
                className={`form-control ${formik.touched.lastName && formik.errors.lastName ? "is-invalid" : ""}`}
                id="lastName"
                name="lastName"
                placeholder="Doe"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.lastName}
              />
              {formik.touched.lastName && formik.errors.lastName && (
                <small className="text-danger">{formik.errors.lastName}</small>
              )}
            </div>
          </div>

          {/* Email */}
          <div className="mb-3">
            <label htmlFor="email" className="form-label">Email Address</label>
            <div className="input-group">
              <span className="input-group-text"><i className="bi bi-envelope" /></span>
              <input
                type="email"
                id="email"
                name="email"
                className={`form-control ${formik.touched.email && formik.errors.email ? "is-invalid" : ""}`}
                placeholder="name@example.com"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.email}
              />
            </div>
            {formik.touched.email && formik.errors.email && (
              <small className="text-danger">{formik.errors.email}</small>
            )}
          </div>
          <div className="mb-3">
            <label htmlFor="email" className="form-label">Phone</label>
            <div className="input-group">
              <span className="input-group-text"><i className="bi bi-phone" /></span>
              <input
                type="number"
                id="phone"
                name="phone"
                className={`form-control ${formik.touched.phone && formik.errors.phone ? "is-invalid" : ""}`}
                placeholder=""
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.phone}
              />
            </div>
            {formik.touched.phone && formik.errors.phone && (
              <small className="text-danger">{formik.errors.phone}</small>
            )}
          </div>

          {/* Password */}
          <div className="mb-3">
            <label htmlFor="password" className="form-label">Password</label>
            <div className="input-group">
              <span className="input-group-text">
                <i
                  className={!showPassword ? "bi bi-lock" : "bi bi-unlock"}
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowPassword(!showPassword)}
                ></i>
              </span>
              <input
                type={!showPassword ? "password" : "text"}
                id="password"
                name="password"
                className={`form-control ${formik.touched.password && formik.errors.password ? "is-invalid" : ""}`}
                placeholder="Enter password"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.password}
              />
            </div>
            {formik.touched.password && formik.errors.password && (
              <small className="text-danger">{formik.errors.password}</small>
            )}
          </div>

          {/* Confirm Password */}
          <div className="mb-4">
            <label htmlFor="confirmPassword" className="form-label">Confirm Password</label>
            <div className="input-group">
              <span className="input-group-text"><i className="bi bi-shield-check" /></span>
              <input
                type="password"
                id="confirmPassword"
                name="confirmPassword"
                className={`form-control ${formik.touched.confirmPassword && formik.errors.confirmPassword ? "is-invalid" : ""}`}
                placeholder="Repeat password"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.confirmPassword}
              />
            </div>
            {formik.touched.confirmPassword && formik.errors.confirmPassword && (
              <small className="text-danger">{formik.errors.confirmPassword}</small>
            )}
          </div>

          <button
            type="submit"
            className="btn btn-gradient w-100"
            disabled={formik.isSubmitting}
          >
            {formik.isSubmitting ? "Creating Account..." : "Sign Up"}
          </button>

          <div className="mt-4 text-center">
            Already have an account? <Link to="/" className="forgot-password cursor text-info "><u>Login</u></Link>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Signup;